var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(_vm.codigoInterno)?_c('span',_vm._g({staticClass:"caption"},on),[_c('b',[_vm._v("#")]),_vm._v(_vm._s(_vm.codigoInterno)+" - ")]):_vm._e()]}}])},[_c('span',[_vm._v("Código interno")])])}
var staticRenderFns = []

export { render, staticRenderFns }